export const ASSET_URL =
  "https://raw.githubusercontent.com/microsoft/fluentui/master/packages/react-components/react-card/assets/";
export const SVG_POWER_POINT = "/powerpoint_logo.svg";
export const SVG_EXCEL = "/excel_logo.svg";
export const VISIO_SVG =
  "https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/svg/visio_16x1.svg";
export const WORD_SVG =
  "https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/svg/word_16x1.svg";
export const PPT_SVG =
  "https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/svg/powerpoint_16x1.svg";
export const EXCEL_SVG =
  "https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/svg/excel_16x1.svg";
export const TEAMS_SVG =
  "https://res-1.cdn.office.net/shellux/teams_24x.1da2a0886d3c616a6242b1f249a9bdce.svg";
//introduction of skillingid if this is set to true
export const DISABLE_TPID_FLAG = "FeatureManagement:disabletpid";
export const FEATURE_FLAGS_QUERY_KEY = "FeatureFlags"
export const FEATURE_FLAG_ENDPOINT= '/Enrollment/v5/api/Profile/ReadFeatureFlag';
